export default [
  {
    path: '/engine/rights',
    name: 'engine-rights-edit',
    component: () => import('./routingDroits.vue'),
    props: route => ({
      root: route.query.root || 'interface',
      target: route.query.target || 'all',
      targetId: route.query.id ?? null,
      standalone: true,
    }),
    meta: { engine: true, requiresAdmin: true },
  },
]
